module.exports = __webpack_public_path__ + "static/media/16.b37949d6.svg";